// extracted by mini-css-extract-plugin
module.exports = {"common":"index_common__1-OiG","child":"index_child__3HClP","header":"index_header__2bpTz"};